import { createContext, useContext, useEffect, useState } from "react";
import { ThemeContextProviderProps, ThemeContextType, ThemeTypes } from "./ContextTypes";
import { AccentTypes } from "../components/settingsComp/SettingsTypes";
import { accentColors } from "../components/settingsComp/ThemeSettings";
import { useUserData } from "./UserDataContext";

const ThemeContext = createContext<ThemeContextType>({
    theme: 'colorful',
    setTheme: () => {}
})

export const ThemeContextProvider = (props: ThemeContextProviderProps) => {

    const BASE_URL = process.env.REACT_APP_BASE_URL
    
	//const { userTheme } = useUserData()
	const localTheme = localStorage.getItem("theme")

    const [theme, setTheme] = useState<ThemeTypes>("colorful");

	useEffect(() => {
		if (localTheme){
			setTheme(localTheme as ThemeTypes)
		}
	}, [])

  /* useEffect(() => {
    const fetchAndStoreUser = async () => {
      try {
        const user = sessionStorage.getItem("user");
        const parsedUser = JSON.parse(user!);
        const username = parsedUser.preferred_username;
        const token = localStorage.getItem("access_token");
        const response = await fetch(`${BASE_URL}/identity_manager/api/v1/getuser/${username}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch user data");

        const userData = await response.json();
        const { id, profilePicUrl, password, ...userDetails } = userData;
        sessionStorage.setItem("userdetails", JSON.stringify(userDetails));
        console.log("USER DETAILS: ", JSON.stringify(userDetails))
        // Update theme after storing user details
        if (userDetails.thememodebconex) {

            setTheme(userDetails.thememodebconex as ThemeTypes);
            const found = accentColors.find(accent => accent.name === userDetails.themecolorbconex)

            if (found !== undefined) document.documentElement.style.setProperty("--color-accent", found.color)

        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    // Initialize theme from storage
    const initializeTheme = () => {
      let userData = sessionStorage.getItem("userdetails");
      if (userData === null) {
        userData = sessionStorage.getItem("user");
      }

      if (userData) {
        try {
          const parsedUser = JSON.parse(userData);
          if (parsedUser.thememodebconex) {
            setTheme(parsedUser.thememodebconex as ThemeTypes);
          }
        } catch (error) {
          console.error("Error parsing sessionStorage user:", error);
        }
      }
    };

    initializeTheme();
    fetchAndStoreUser();
  }, []); */

    

    useEffect(() => {
        localStorage.setItem("theme", theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{theme, setTheme}}>
            {props.children}
        </ThemeContext.Provider>
    )
}

export const useTheme = () => {
    const context = useContext(ThemeContext)

    if(!context) throw new Error("useTheme must be used within an ThemeProvider")
    
        return context
}